import React, { useEffect, useState } from "react";
import defaultClasses from './spinTheWheel.css';
import { FormattedMessage } from 'react-intl';
import ChildrenPopup from "../ChildrenPopup";
import Icon from "../Icon";
import { useLocation } from 'react-router-dom';
import { X as CloseIcon } from 'react-feather';
import BrowserPersistence from "@magento/peregrine/lib/util/simplePersistence";
import { useAppContext } from "@magento/peregrine/lib/context/app";
import { useFeatureIsOn, useFeatureValue } from "@growthbook/growthbook-react";
var storage = new BrowserPersistence();
var STORAGE_POPUP_SEEN_KEY = 'promotion_popup_seen';
export var STORAGE_SPIN_WON_COUPON_KEY = 'promotion_coupon_won';
var EASY_COUPON_PREFIX = 'COUPON_CODE:';
var visibleTimeout;
var SpinTheWheel = props => {
  var {
    isPopup,
    placement
  } = props;
  return null;
  var {
    pathname
  } = useLocation();
  var [popupVisible, setPopupVisible] = useState(false);
  var [{
    storeConfig
  }] = useAppContext();
  var {
    enabled,
    promo_link,
    promo_popup_delay,
    promo_popup_placement,
    promo_popup_enabled,
    promo_popup_revisit_delay
  } = (storeConfig === null || storeConfig === void 0 ? void 0 : storeConfig.easy_promos_app) || {};
  var isPromoUrl = pathname.includes('promotion-game');
  var checkPlacement = () => {
    var growthBookTestEnabled = useFeatureIsOn("easy-promo-popup-placement");
    if (growthBookTestEnabled) {
      var value = useFeatureValue('easy-promo-popup-placement');
      return placement === value;
    }
    return placement === promo_popup_placement;
  };
  var popupSeen = storage.getItem(STORAGE_POPUP_SEEN_KEY);
  var enablePopup = checkPlacement() && isPopup && enabled && promo_popup_enabled && promo_link && !popupSeen && !isPromoUrl;
  var renderedFrame = /*#__PURE__*/React.createElement("iframe", {
    id: 'easy-popup',
    frameBorder: "0",
    src: promo_link,
    className: defaultClasses.iframe,
    allow: "clipboard-read; clipboard-write"
  });
  useEffect(() => {
    if (enablePopup) {
      setTimeout(() => {
        setPopupVisible(true);
      }, promo_popup_delay);
    }
  }, [enablePopup]);
  var getCouponFromEasyPromosApp = event => {
    console.log('EVENT RECEIVED', event);
    // Do we trust the sender of this message?  (might be
    // different from what we originally opened, for example).
    if (event.origin !== "https://pr.easypromosapp.com" || !event.data || !event.data.startsWith(EASY_COUPON_PREFIX)) {
      return;
    }
    var coupon_code = event.data.replace(EASY_COUPON_PREFIX, '');
    console.log(coupon_code);
    if (coupon_code && coupon_code.length) {
      storage.setItem(STORAGE_SPIN_WON_COUPON_KEY, coupon_code, promo_popup_revisit_delay * 1000);
    }
  };

  // if popup still visible on screen after popup had been shown + 4sec
  // setting it as seen, otherwise consider as not seen
  useEffect(() => {
    if (enablePopup && popupVisible && promo_popup_revisit_delay || isPromoUrl) {
      visibleTimeout = setTimeout(() => {
        storage.setItem(STORAGE_POPUP_SEEN_KEY, true, promo_popup_revisit_delay * 1000);
        window.addEventListener("message", getCouponFromEasyPromosApp, false);
      }, 3000);
    } else if (visibleTimeout) {
      clearTimeout(visibleTimeout);
    }
    return () => window.removeEventListener("message", getCouponFromEasyPromosApp, false);
  }, [popupVisible]);
  if (isPopup) {
    if (enablePopup && popupVisible) {
      return /*#__PURE__*/React.createElement(ChildrenPopup, {
        visiblePopup: true
      }, /*#__PURE__*/React.createElement("div", {
        className: defaultClasses.popupContent
      }, /*#__PURE__*/React.createElement("div", {
        className: defaultClasses.closeBtn,
        onClick: () => setPopupVisible(false)
      }, /*#__PURE__*/React.createElement(Icon, {
        attrs: {
          fill: '#ffffff',
          stroke: '#ffffff'
        },
        src: CloseIcon,
        size: 40
      })), renderedFrame));
    }

    // avoid moving forward in a component
    // if calling this component as a popup
    return null;
  }
  if (enabled && promo_link) {
    return renderedFrame;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.disabledRoot
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'spinTheWheel.disabled',
    defaultMessage: 'Sorry, spin is not enabled right now, please try again later.'
  })));
};
export default SpinTheWheel;